import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/** @jsx jsx */

import React from 'react';
import { jsx } from 'theme-ui';
import { Link } from 'gatsby';
import { useDocs, useCurrentDoc } from 'docz';
import { get } from 'lodash/fp';
import * as styles from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";

const getHeadings = (route, docs) => {
  const doc = docs.find(doc => doc.route === route);
  const headings = get('headings', doc);
  return headings ? headings.filter(heading => heading.depth === 2) : [];
};

const getCurrentHash = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location ? decodeURI(window.location.hash) : '';
};

export const NavLink = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    item
  } = _ref,
      props = _objectWithoutProperties(_ref, ["item"]);

  const docs = useDocs();
  const current = useCurrentDoc();

  if (item.hidden) {
    return null;
  }

  const to = item.route;
  const headings = docs && getHeadings(to, docs);
  const isCurrent = item.route === current.route;
  const showHeadings = isCurrent && headings && headings.length > 0;
  const currentHash = getCurrentHash();
  return jsx(React.Fragment, null, jsx(Link, _extends({}, props, {
    to: to,
    sx: styles.link,
    activeClassName: "active",
    ref: ref
  })), showHeadings && headings.map(heading => jsx(Link, {
    key: heading.slug,
    to: `${to}#${heading.slug}`,
    sx: styles.smallLink,
    className: currentHash === `#${heading.slug}` ? 'active' : ''
  }, heading.value)));
});

if (typeof NavLink !== 'undefined' && NavLink && NavLink === Object(NavLink) && Object.isExtensible(NavLink) && !NavLink.hasOwnProperty('__filemeta')) {
  Object.defineProperty(NavLink, '__filemeta', {
    configurable: true,
    value: {
      name: "NavLink",
      filename: "../../node_modules/gatsby-theme-docz/src/components/NavLink/index.js"
    }
  });
}